import { Link } from 'react-router-dom';

const LINK_GROUPS = [
  {
    title: '内容导航',
    links: [
      { label: '电影频道', to: '/category/movie' },
      { label: '电视剧频道', to: '/category/tv' },
      { label: '综艺频道', to: '/category/variety' },
      { label: '影视资讯', to: '/news' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { label: '网站介绍', to: '/about' },
      { label: '联系我们', to: '/about' },
      { label: '版权声明', to: '/about' },
      { label: '用户须知', to: '/about' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-950 pb-20 text-primary-100 md:mt-20 md:pb-0">
      <div className="w-full px-4 py-12 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/10">
                <i className="ri-play-fill text-lg text-accent-400" />
              </span>
              <span className="font-heading text-lg font-extrabold tracking-wide text-background-50">
                黄牛视频
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-200">
              黄牛视频是一个聚焦电影、电视剧与综艺内容的影视资讯平台。我们用清晰的分类、及时更新的资讯和克制的推荐，帮你更快找到想看的那一部。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-2 text-xs text-primary-300">
              <span className="rounded-full bg-background-50/10 px-3 py-1">影视资讯</span>
              <span className="rounded-full bg-background-50/10 px-3 py-1">影片推荐</span>
              <span className="rounded-full bg-background-50/10 px-3 py-1">分类筛选</span>
              <span className="rounded-full bg-background-50/10 px-3 py-1">播放演示</span>
            </div>
          </div>

          {LINK_GROUPS.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-bold text-background-50">{group.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-primary-200 transition-colors hover:text-accent-300"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 border-t border-background-50/15 pt-6 md:grid-cols-2">
          <div className="space-y-2 text-xs leading-relaxed text-primary-300">
            <p>
              联系邮箱：<span className="text-primary-100">hello@huangniu-video.example</span>
            </p>
            <p>办公地址：北京市朝阳区望京东路 18 号 影视创意园 B 座 7 层</p>
            <p className="text-primary-400">
              本站影视条目、评分与人物信息均为虚构示例数据；详情页播放区域为前端交互演示，不提供真实视频源，相关播放能力待接入。
            </p>
          </div>
          <div className="flex flex-col gap-3 md:items-end">
            <div className="flex items-center gap-2">
              {['ri-weibo-line', 'ri-wechat-line', 'ri-bilibili-line', 'ri-mail-line'].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/10 text-primary-100"
                >
                  <i className={`${icon} text-base`} />
                </span>
              ))}
            </div>
            <p className="text-xs text-primary-400">
              © 2026 黄牛视频 Huangniu Video · 京ICP备2026000000号
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}